import { Sprite, Filter } from 'pixi.js';

class Bubble {
    constructor(getSceneSize, options) {
        const { id, texture, x, y, xPercent, yPercent, speed, deformX, deformY, deformDelta, fragmentShader } = options;
        this.id = id;
        this.getSceneSize = getSceneSize;
        this.speed = speed;

        this.deformX = deformX;
        this.deformY = deformY;
        this.deformDelta = deformDelta;
        this.yPercent = yPercent;
        this.xPercent = xPercent;

        this.sprite = new Sprite(texture);
        this.sprite.anchor.set(0.5, 0.5);

        this.cloneSprite = new Sprite(texture);
        this.cloneSprite.anchor.set(0.5, 0.5);

        this.resize();

        this.customFilter = new Filter(null, fragmentShader, {
            time: 0,
            deformX: this.deformX,
            deformY: this.deformY,
            delta: this.deformDelta,
        });

        this.customFilter.autoFit = false;

        this.sprite.filters = [this.customFilter];
        this.cloneSprite.filters = [this.customFilter];
    }

    update(delta) {
        const { height } = this.getSceneSize();

        this.sprite.y -= this.speed * delta;

        this.cloneSprite.y = this.sprite.y + height;

        if (this.sprite.y < -this.sprite.height / 2) {
            this.sprite.y = height - this.sprite.height / 2;
            this.cloneSprite.y = this.sprite.y + height;
        }

        this.customFilter.uniforms.time += 0.01 * delta;
    }

    addToStage(stage) {
        stage.addChild(this.sprite);
        stage.addChild(this.cloneSprite);
    }

    resize() {
        const { width, height, scale } = this.getSceneSize();

        const posX = this.xPercent * width / 100;
        const posY = this.yPercent * height / 100;

        this.sprite.x = posX;
        this.sprite.y = posY;
        this.sprite.scale.set(scale, scale);

        this.cloneSprite.x = posX;
        this.cloneSprite.y = posY + this.sprite.height;
        this.cloneSprite.scale.set(scale, scale);
    }
}

export default Bubble;
